module.exports = __webpack_public_path__ + "static/media/woman_searching.d09b2e37.svg";